
const Option = props => {

    return (
                <option>
                    {props.option}
                </option>
    )
}

export default Option;